import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isTransparent = location.pathname === '/' && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              isTransparent ? 'bg-background-50/20' : 'bg-primary-100'
            }`}>
              <i className={`ri-anchor-line text-xl ${
                isTransparent ? 'text-background-50' : 'text-primary-600'
              }`}></i>
            </div>
            <span className={`font-heading font-semibold text-lg whitespace-nowrap ${
              isTransparent ? 'text-background-50' : 'text-foreground-900'
            }`}>
              鲍鱼域名导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname === '/' ? (isTransparent ? 'text-background-50' : 'text-primary-600') : (isTransparent ? 'text-background-50/80' : 'text-foreground-700')
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/domain-entry"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname.startsWith('/category') ? (isTransparent ? 'text-background-50' : 'text-primary-600') : (isTransparent ? 'text-background-50/80' : 'text-foreground-700')
              }`}
            >
              分类导航
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname === '/about' ? (isTransparent ? 'text-background-50' : 'text-primary-600') : (isTransparent ? 'text-background-50/80' : 'text-foreground-700')
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              isTransparent ? 'text-background-50 hover:bg-background-50/10' : 'text-foreground-700 hover:bg-background-100'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">首页</Link>
            <Link to="/category/domain-entry" className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">分类导航</Link>
            <Link to="/about" className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}